import { useNavigate, useLocation, useParams } from "react-router-dom";

export function withNavigation(Component) {
  return function WithNavigation(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
      />
    );
  };
}